import { render, staticRenderFns } from "./IconCard.vue?vue&type=template&id=6832c723&scoped=true"
import script from "./IconCard.vue?vue&type=script&lang=js"
export * from "./IconCard.vue?vue&type=script&lang=js"
import style0 from "./IconCard.vue?vue&type=style&index=0&id=6832c723&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6832c723",
  null
  
)

export default component.exports